<template>
    <az-container>
        <az-form>
            <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                          :pagination.sync="value" :loading="false"
                          :no-data-text="textoVazio" :style="cssVar" hide-actions
                          class="az-table-list listagem-tabela">
                <template slot="items" slot-scope="props">
                    <tr @click="$emit('acessar', props.item.id)" :key="props.item.id">
                        <td>
                            {{ props.item.dataHoraAbertura | az-date(humanizarFormatoData(props.item.dataHoraEncerramento)) }}<br>
                            <span v-if="props.item.dataHoraAbertura">
                                {{ props.item.dataHoraAbertura | az-date(humanizarFormatoHora(props.item.dataHoraEncerramento)) }}
                            </span>
                        </td>
                        <td>
                            {{ props.item.processo }}
                        </td>
                        <td>
                            <expansao-texto :tamanho="150" :texto="props.item.objeto ? props.item.objeto : ''"></expansao-texto>
                        </td>
                        <td>
                            {{ props.item.numero }}
                        </td>
                        <td>
                            {{ props.item.orgao }}
                        </td>
                        <td class="table-actions">
                            <v-tooltip top>
                                <a slot="activator">
                                    <i class="fas fa-sign-in-alt pr-2" aria-hidden="true" @click="$emit('acessar', props.item.id)"/>
                                    <span class="acao-mobile">Acessar</span>
                                </a>
                                Acessar
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <div class="az-pagination">
                <v-pagination v-model="value.page" :length="paginas" :total-visible="25" @input="$emit('paginar')"/>
                <div class="az-select-pagination">
                    <span>Linhas por página:</span>
                    <v-select :items="linhasPorPagina" v-model="value.rowsPerPage" @input="$emit('paginar')"/>
                </div>
            </div>
        </az-form>
    </az-container>
</template>

<script>
import {tiposCompraDireta} from '@/core/constants'

export default {
    name: 'ListagemCompraDiretaLegada',
    props: {
        itens: {
            type: Array,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        paginas: Number,
        textoVazio: String,
        totalItens: Number
    },
    data() {
        return {
            paginacaoInterna: this.paginacao,
            linhasPorPagina: [10, 25, 50, 100],
            colunas: [
                {
                    value: 'dataHoraAbertura',
                    sortable: true,
                    text: 'Abertura',
                    width: '40px',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    align: 'left',
                    sortable: true,
                    text: 'Nº Processo',
                    width: '100px',
                    value: 'processo',
                    class: 'primary--text'
                },
                {
                    value: 'objeto',
                    sortable: true,
                    width: '250px',
                    text: 'Objeto',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    sortable: true,
                    align: 'left',
                    width: '80px',
                    text: 'Número',
                    value: 'numero',
                    class: 'primary--text'
                },
                {
                    value: 'orgao',
                    align: 'left',
                    sortable: false,
                    width: '30px',
                    text: this.$t('main.commons_listagem_situacao.text'),
                    class: 'primary--text'
                },
                {
                    text: 'Ações',
                    sortable: false,
                    width: '30px',
                    align: 'center',
                    class: 'primary--text'
                }
            ],
            tiposCompraDireta
        }
    },
    computed: {
        cssVar() {
            const labelOrgao = this.$t('main.commons_listagem_situacao.text')
            return {
                '--label-orgao': `"${labelOrgao}:"`
            }
        },
    },
}
</script>

<style scoped lang="stylus">
    .az-container
        margin-bottom 60px

    .listagem-tabela
        .acao-mobile
            display none

        td:hover
            cursor pointer !important

    @media (max-width 720px)
        .listagem-tabela
            td:nth-of-type(1):before
                content "Encerramento:"

            td:nth-of-type(2):before
                content "Nº Processo:"

            td:nth-of-type(3):before
                content "Objeto:"

            td:nth-of-type(4):before
                content "Tipo:"

            td:nth-of-type(5):before
                content var(--label-orgao)

            td:nth-of-type(6):before, td:nth-of-type(1) br
                display none

            .acao-mobile
                display inline-block
                margin-left 3px

    @media (max-width 500px)
        .az-container
            margin-bottom 0
</style>
